module.exports = __webpack_public_path__ + "assets/img/c13.7c7e854b.png";